module.exports = __webpack_public_path__ + "static/media/volvo-go-drive.f03970ff.png";